import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-settings-footer',
    templateUrl: './settings-footer.component.html',
    styleUrls: ['./settings-footer.component.scss'],
})
export class SettingsFooterComponent {
    @Input() buttonText = 'request_v2.settings_dialog.next';

    @Input() isLoading = false;

    @Output() next = new EventEmitter<void>();

    onNextClick(): void {
        this.next.emit();
    }
}
